import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 6h-6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H2v15h20V6zm-8 0h-4V4h4v2z"
}), 'WorkSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WorkSharp.js
// module id = 7309
// module chunks = 2